import { MapPin, Phone, Mail, Clock, Send, CheckCircle } from 'lucide-react';
import { useState } from 'react';

const contactPoints = [
  {
    icon: MapPin,
    title: 'Адрес офиса',
    details: 'г. Сургут, ул. Майская, 10',
    description: 'Центральный офис АНО ДПО «Институт развития компетенций»',
  },
  {
    icon: Phone,
    title: 'Телефон',
    details: '+7 (909) 71-22-777',
    description: 'Пн–Пт с 7:00 до 16:00 (по московскому времени)',
  },
  {
    icon: Mail,
    title: 'Email',
    details: 'info@o4ki.online',
    description: 'Общие вопросы, партнёрство, пресса',
  },
  {
    icon: Clock,
    title: 'Режим работы',
    details: 'Пн–Пт: 9:00–18:00',
    description: 'Суббота и воскресенье — выходные',
  },
];

const departments = [
  { name: 'Регистрация участников', email: 'registration@o4ki.online' },
  { name: 'Техническая поддержка', email: 'support@o4ki.online' },
  { name: 'Партнёрство и спонсорство', email: 'partner@o4ki.online' },
  { name: 'Пресс-служба', email: 'press@o4ki.online' },
  { name: 'Волонтёры', email: 'volunteer@o4ki.online' },
];

export default function ContactsPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Здесь будет отправка формы
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Контакты</h1>
        <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
          Свяжитесь с нами по любым вопросам, связанным с чемпионатом. Мы ответим в ближайшее время.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
        {contactPoints.map((point) => (
          <div key={point.title} className="card text-center hover:shadow-xl transition-shadow">
            <div className="inline-flex p-4 bg-primary-100 rounded-full mb-4">
              <point.icon className="h-8 w-8 text-primary-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900">{point.title}</h3>
            <p className="text-gray-700 font-semibold mt-2">{point.details}</p>
            <p className="text-gray-500 text-sm mt-2">{point.description}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
        <div className="lg:col-span-2">
          <div className="card">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Напишите нам</h2>
            {submitted ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center">
                <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold text-green-800">Сообщение отправлено!</h3>
                <p className="text-green-700 mt-2">
                  Мы получили ваше обращение и ответим в течение 24 часов.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ваше имя *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="input-field"
                      placeholder="Иван Иванов"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="input-field"
                      placeholder="example@mail.ru"
                      required
                    />
                  </div>
                </div>
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Тема *
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="input-field"
                    placeholder="Вопрос о регистрации"
                    required
                  />
                </div>
                <div className="mb-8">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Сообщение *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    className="input-field resize-none"
                    placeholder="Опишите ваш вопрос или предложение..."
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn-primary inline-flex items-center justify-center w-full"
                >
                  <Send className="h-5 w-5 mr-2" />
                  Отправить сообщение
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="space-y-8">
          <div className="card">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Отделы и ответственные</h3>
            <div className="space-y-6">
              {departments.map((dept) => (
                <div key={dept.name} className="flex justify-between items-center border-b border-gray-100 pb-4">
                  <div>
                    <p className="font-semibold text-gray-900">{dept.name}</p>
                    <p className="text-gray-500 text-sm">{dept.email}</p>
                  </div>
                  <a
                    href={`mailto:${dept.email}`}
                    className="text-primary-600 hover:text-primary-800 font-medium"
                  >
                    Написать
                  </a>
                </div>
              ))}
            </div>
          </div>

          <div className="card bg-gradient-to-br from-primary-50 to-accent-50">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">MAX-чат поддержки</h3>
            <p className="text-gray-700 mb-6">
              Для быстрых ответов присоединяйтесь к нашему MAX-чату. Там участники и организаторы
              обсуждают вопросы, делятся новостями и помогают друг другу.
            </p>
            <a
              href="https://max.ru/join/K8Jb-740TCVsQW2qnZVqgPpzFv-ObTp-M4rL79d3rq4"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center justify-center w-full"
            >
              Перейти в чат
            </a>
          </div>

          <div className="card">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Мы на карте</h3>
            <div className="aspect-video bg-gray-200 rounded-xl overflow-hidden">
              <iframe
                src="https://maps.google.com/maps?q=Сургут, ул. Майская, д. 10&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Карта офиса"
              />
            </div>
            <p className="text-gray-500 text-sm mt-4">
              г. Сургут, ул. Майская, д. 10, 5 минут от остановки «Майская».
            </p>
          </div>
        </div>
      </div>

      <div className="text-center text-gray-500">
        <p>
          Официальный сайт организатора:{' '}
          <a
            href="https://irk‑hanty.ru"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 hover:underline"
          >
            АНО ДПО «Институт развития компетенций»
          </a>
        </p>
        <p className="mt-2 text-sm">
          © 2026 Онлайн-чемпионат Югры по креативным индустриям «ОЧКИ». Все права защищены.
        </p>
      </div>
    </div>
  );
}